import { billingService } from '../../service/billing-service'
import { BillingKey } from '../../model/billing-model'
import { tap } from 'rxjs/operators'

export const namespace = 'BILLING'

export const types = {
  SET_BILLING_KEY: 'SetBillingKey',
  GET_BILLING_KEY: 'getBillingKey'
}

const state = {
  billingKey: new BillingKey()
}

const mutations = {
  [types.SET_BILLING_KEY](state, payload) {
    state.billingKey = payload
  }
}

const actions = {
  [types.GET_BILLING_KEY]({ commit }) {
    return billingService
      .getBillingKey$()
      .pipe(tap(billingKey => commit(types.SET_BILLING_KEY, billingKey)))
      .toPromise()
  }
}

export const billingStore = {
  state,
  mutations,
  actions,
  namespace,
  types
}
